import React, {useEffect} from "react";
import { useSelector } from "react-redux";

function ReusableComponentCard({
  index,
  item,
  getIcon,
  handleDragStart,
  handleDragEnd
}) {
  const { componentGridLayoutData } = useSelector(
    (state) => state.bookingTemplate
  );

  return (
    <div
      key={index}
      draggable={
        !componentGridLayoutData?.some(
          (component) => component.component?.componentId === item.component_id
        )
      }
      onDragStart={(event) => {
        const componentObj = {
          componentType: item.type,
          componentId: item.component_id,
          componentName: item.label,
          componentPlaceholder: item.placeholder,
          componentTooltip: item.tooltip,
          isCheckedByDefault: item.is_check_by_default,
          validation: item.validation_api_id,
          minimumValue: item.min,
          maximumValue: item.max,
          component_special_id: item.component_name,
          priorDate: item.prior_date,
          futureDate: item.future_date,
          isMandatory: false,
          dropDownOption: item.list_values
            ? JSON.parse(item.list_values)
            : item.list_values,
          link_url: item.url,
          column_number: {
            label: "6",
            value: 6,
          },
        };
        event.dataTransfer.setData("text/plain", JSON.stringify(componentObj));
        handleDragStart()
      }}
      onDragEnd={handleDragEnd}
      className={`h-[58px] ${
        !componentGridLayoutData?.some(
          (component) => component.component.componentId === item.component_id
        )
          ? "bg-[#F3F7FE] cursor-pointer"
          : "bg-[--bg-color-500] cursor-not-allowed"
      } rounded flex items-center space-x-2 px-2`}
    >
      <div className="w-[15%] flex justify-center items-center text-lg">
        {getIcon(
          item.type,
          componentGridLayoutData?.some(
            (component) => component.component.componentId === item.component_id
          )
        )}
      </div>
      <div className="space-y-0.5 w-2/3">
        <h5
          title={item.label}
          className={`text-sm leading-5 font-semibold text-[#1E293B tracking-tight] ${
            componentGridLayoutData?.some(
              (component) => component.component.componentId === item.component_id
            )
              ? "text-white"
              : "text-[#1E293B]"
          } w-full overflow-hidden truncate`}
        >
          {item.label}
        </h5>
        <p
          title={item.component_name}
          className={`${
            componentGridLayoutData?.some(
              (component) => component.component.componentId === item.component_id
            )
              ? "text-white"
              : "text-[#475569]"
          } text-xs leading-4 tracking-tight w-full overflow-hidden truncate`}
        >
          {item.component_name}
        </p>
      </div>
    </div>
  );
}

export default ReusableComponentCard;
